module.exports = __webpack_public_path__ + "img/horizontal_2_1_5010.480161f6.png";